/**
 * Score color and label helpers for the Home Safety Audit.
 * Thresholds per .planning/phases/03-frontend/03-UI-SPEC.md "Score Color Coding".
 *
 * Bands:
 *   null           -> muted (N/A — e.g. stairs when stairsNa)
 *   < 5            -> red   ("Needs Attention")
 *   5 – 7.5        -> amber ("Fair")
 *   > 7.5          -> green ("Good")
 */

export const getScoreColor = (score: number | null): string => {
  if (score === null) return 'text-muted-foreground bg-muted';
  if (score < 5) return 'text-red-600 bg-red-50';
  if (score <= 7.5) return 'text-amber-600 bg-amber-50';
  return 'text-green-600 bg-green-50';
};

export const getScoreLabel = (score: number | null): string => {
  if (score === null) return 'N/A';
  if (score < 5) return 'Needs Attention';
  if (score <= 7.5) return 'Fair';
  return 'Good';
};
